<template>
  <!--pdf预览-->
  <el-dialog
    :visible.sync="visibleShowEnclosureDoc"
    width="70%"
    :title="enclosurePreviewNumItem && enclosurePreviewNumItem.file ? enclosurePreviewNumItem.file.fileName : ''"
    modal-append-to-body
    class="show-evidence__dailog enclosure-dialog"
    @open="enclosureLoading = true"
    @opened="wenOpen(enclosurePreviewNumItem.file)"
    @close="wenClose"
  >
<!--    <h1-->
<!--      class="h-title"-->
<!--      v-if="-->
<!--        enclosurePreviewNumItem.file && enclosurePreviewNumItem.file.fileName-->
<!--      "-->
<!--    >-->
<!--      {{ enclosurePreviewNumItem.file.fileName }}-->
<!--    </h1>-->
    <div
      style="height:95vh;width: 100%;overflow: hidden;"
      v-loading="enclosureLoading"
      id="wenWrap"
    ></div>
  </el-dialog>
</template>

<script>
import { getFindFileDownload } from "../../assets/js/http-serve/http-methods";
export default {
  name: "ViewFilesToDoc",
  props: {
    visibleShow: {
      type: Boolean,
      default: false
    },
    enclosurePreviewNumItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {
    visibleShow(val) {
      this.visibleShowEnclosureDoc = val;
    }
  },
  data() {
    return {
      enclosureLoading: false,
      visibleShowEnclosureDoc: false //附件弹窗加载时的loading
    };
  },
  methods: {
    // 生成pdf 预览地址
    previewPDF(file) {
      let serverUrl = "/pdf/web/viewer.html";
      let pdfUrl = this.downloadAttatchFile(file); // 调取接口返回文件流
      return `${serverUrl}?file=${encodeURIComponent(pdfUrl)}`;
    },
    /**
     * pdf预览弹窗打开
     */
    wenOpen(file) {
      this.enclosureLoading = true;
      let _self = this;
      let src = this.previewPDF(file);
      let iframe = document.createElement("iframe");
      iframe.src = src;
      iframe.width = "100%";
      iframe.height = "100%";
      iframe.frameborder = 1;
      if (iframe.attachEvent) {
        iframe.attachEvent("onload", function() {
          _self.enclosureLoading = false;
        });
      } else {
        iframe.onload = function() {
          _self.enclosureLoading = false;
        };
      }
      document.getElementById("wenWrap").appendChild(iframe);
    },
    /**
     * pdf预览弹窗关闭
     */
    wenClose() {
      document.getElementById("wenWrap").innerHTML = "";
      this.$emit("setViewFilesToDocDialogData", {
        visibleShow: false,
        obj: {}
      });
    },
    downloadAttatchFile(param) {
      console.log("paramFile", param);
      if (!param || param === "null" || param === "false")
        return "javascript:void(0)";
      if (param.fileName === "blob") {
        param.fileName = "attachment.png";
        param.fix = ".png";
      }
      return getFindFileDownload(param);
    }
  }
};
</script>

<style lang="less" scoped>
.enclosure-dialog {
  /deep/ .el-dialog__body {
    padding: 0;
    max-height: 85vh;
  }
  /deep/ .el-dialog__headerbtn {
    z-index: 5;
  }
  .h-title {
    background: #ffffff;
    z-index: 2;
    line-height: initial;
    text-align: left;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding: 10px;
    width: 100%;
    /*position: absolute;*/
    /*top:0;*/
    /*left:0;*/
    /*right: 0;*/
    border-bottom: 1px solid #eeeeee;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }
  .box-wrap {
    height: 460px;
    line-height: 430px;
    padding: 15px;
    box-sizing: border-box;
    img {
      max-height: 430px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/viewFiles/ViewFilesToDoc.vue